<section class="service-picker">
  <div class="service-picker__search">
    <div class="service-picker__input-wrap">
      <i class="fa-solid fa-magnifying-glass"></i>

      <input
        type="text"
        [value]="query"
        [placeholder]="placeholder"
        autocomplete="off"
        (focus)="onFocus()"
        (input)="onInput($event)"
      />

      <button
        type="button"
        class="service-picker__refresh"
        (click)="refreshRequested.emit()"
        [disabled]="loading"
        aria-label="Actualizar servicios"
      >
        <i
          class="fa-solid"
          [class.fa-rotate]="!loading"
          [class.fa-spinner]="loading"
          [class.fa-spin]="loading"
        ></i>
      </button>
    </div>
  </div>

  @if (showSuggestions) {
    <div
      class="service-picker__suggestions"
      role="listbox"
      aria-label="Sugerencias de servicios"
    >
      @if (query.trim().length === 0 && !loading) {
        <small class="service-picker__hint">
          Selecciona un servicio o escribe para buscar.
        </small>
      }

      @if (loading) {
        <small class="service-picker__hint"> Cargando servicios... </small>
      } @else {
        @for (service of filteredSuggestions; track service.id) {
          <button type="button" (click)="onAdd(service)">
            <div class="service-picker__service">
              <span>{{ getServiceLabel(service) }}</span>
            </div>

            <div class="service-picker__add">
              <i class="fa-solid fa-plus"></i>
            </div>
          </button>
        }

        @if (filteredSuggestions.length === 0) {
          <div class="service-picker__empty" role="status" aria-live="polite">
            <span class="service-picker__empty-icon">
              <i class="fa-solid fa-magnifying-glass"></i>
            </span>

            <div>
              <strong>No se encontraron coincidencias</strong>
              <small>Intenta con otro nombre</small>
            </div>
          </div>
        }
      }
    </div>
  }
</section>
